export default __webpack_public_path__ + "static/expert-1-f53a63df429e2f08a21f5919195b07d6.jpg";